import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { clearConnectionsAction } from '../../redux/reducers/connections.reducer';
import { clearGlobalStateAction } from '../../redux/reducers/global.reducer';

const hasStoredSession = () => Boolean(localStorage.getItem('token'));

function NotProtectedRoute() {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!hasStoredSession()) {
            return;
        }

        localStorage.clear();
        dispatch(clearConnectionsAction());
        dispatch(clearGlobalStateAction());
    }, [dispatch]);

    return <Outlet />;
}

export default NotProtectedRoute;
